module.exports = __webpack_public_path__ + "img/BY.37de1b3e.svg";